import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { LOAN_TERM_MESSAGES } from '../../../constants/loan'

const propTypes = {
  className: PropTypes.string,
  adjustable: PropTypes.bool,
  years: PropTypes.number,
  months: PropTypes.number,
  armYearsInitial: PropTypes.number,
}

export const Adjustable = ({ years }) => (
  <FormattedMessage {...LOAN_TERM_MESSAGES.arm} values={{ years }} />
)

export const Fixed = ({ years }) => (
  <FormattedMessage {...LOAN_TERM_MESSAGES.fix} values={{ years }} />
)

const LoanTerm = ({ className, adjustable, years, months }) => {
  const termYears = years || Math.round(months / 12)
  const Copy = adjustable ? Adjustable : Fixed
  return <Copy years={termYears} />
}

LoanTerm.propTypes = propTypes

export default LoanTerm
